import * as React from "react";
const IconServer15 = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M60.5 55.4h-1.3v-7.8c0-1.8-1.5-3.3-3.3-3.3H43.5c-1.8 0-3.3 1.5-3.3 3.3v7.8H39c-.6 0-1 .4-1 1s.4 1 1 1h21.6c.6 0 1-.4 1-1s-.5-1-1.1-1m-18.3 0v-7.8c0-.7.6-1.3 1.3-1.3H56c.7 0 1.3.6 1.3 1.3v7.8z" />
    <path d="M62 24.1V10.9c0-2.8-2.2-5-5-5H7c-2.8 0-5 2.2-5 5v13.2c0 1.6.8 3.1 2 4-1.2.9-2 2.4-2 4v13.2c0 2.8 2.2 5 5 5h29.3c.6 0 1-.4 1-1s-.4-1-1-1H7c-1.7 0-3-1.3-3-3V32.1c0-1.7 1.3-3 3-3h50c1.7 0 3 1.3 3 3v9.6c0 .6.4 1 1 1s1-.4 1-1v-9.6c0-1.6-.8-3.1-2-4 1.2-.9 2-2.4 2-4m-2 0c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V10.9c0-1.7 1.3-3 3-3h50c1.7 0 3 1.3 3 3z" />
    <path d="M15.6 16.3c-.6 0-1 .4-1 1v.2c0 .6.4 1 1 1s1-.4 1-1v-.2c0-.6-.5-1-1-1M50.8 16.4H44c-.6 0-1 .4-1 1s.4 1 1 1h6.7c.6 0 1-.4 1-1s-.4-1-.9-1M14.6 38.5v.2c0 .6.4 1 1 1s1-.4 1-1v-.2c0-.6-.4-1-1-1s-1 .4-1 1M50.8 39.5c.6 0 1-.4 1-1s-.4-1-1-1H44c-.6 0-1 .4-1 1s.4 1 1 1z" />
  </svg>
);
export default IconServer15;
